import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { Modal } from '../Modal/Modal.js';
import { ModalContent } from '../Modal/ModalContent.js';
import { Slide } from '../Transition/index.js';
export { DrawerSection } from './DrawerSection.js';
import '../Box/index.js';
import '../CloseButton/index.js';
import '../Stack/index.js';
import '../Text/index.js';
import '../Link/index.js';
import '../Loading/index.js';

/**
 * The Drawer component is a panel that slides out from the edge of the screen.
 * It can be useful when you need users to complete a task or view some details
 * without leaving the current page. Contents behind a drawer are inert meaning
 * that users cannot interact with content behind the dialog.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/drawer#props)
 * - [Props](https://blockparty.endpoint.com/components/drawer#props)
 * <br />
 *
 */
const Drawer = _ref => {
  let {
    children,
    isOpen,
    onClose,
    maxWidth,
    placement = 'right',
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Modal, _extends({
    formatIds: id => ({
      content: `drawer-${id}`,
      header: `drawer-${id}-header`,
      body: `drawer-${id}-body`
    }),
    isOpen: isOpen,
    transitionDuration: 300,
    onClose: onClose
  }, rest), /*#__PURE__*/React__default.createElement(Slide, {
    from: placement,
    isOpen: isOpen,
    maxWidth: maxWidth
  }, children));
};
/// /////////////////////////////////////////////////////////////////////
const StyledDrawerContent = styled(ModalContent).withConfig({
  displayName: "Drawer__StyledDrawerContent",
  componentId: "sc-9v2qtj-0"
})(["display:flex;flex-direction:column;border-radius:0;height:100%;max-width:initial;position:relative;left:0;top:0;transform:initial;"]);
const DrawerContent = /*#__PURE__*/forwardRef((_ref2, forwardedRef) => {
  let {
    children,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React__default.createElement(StyledDrawerContent, _extends({
    ref: forwardedRef
  }, rest), children);
});

export { Drawer, DrawerContent };
